import { render, staticRenderFns } from "./IssueMap.vue?vue&type=template&id=48e355aa&"
import script from "./IssueMap.vue?vue&type=script&lang=js&"
export * from "./IssueMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports